import { NetworkManager } from "../network_manager.js";
import { OfflineJournal } from "./offline_journal.js";

export function shouldGoLocal(): boolean
{
  return !NetworkManager.isOnline() || OfflineJournal.hasPending();
}
